//React
import React from "react";
//Routing
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
//Components
import LoginPage from "../../Features/Authentication/LoginPage";

import Notifications from "../../Global/notifications/Notifications";

import InstallerLandingPage from "../../Features/Installer/InstallerLandingPage";
import QRCodeScanPage from "../../Features/Installer/QRCodeScanPage";
import ClientDetailsPage from "../../Features/Installer/ClientDetailsPage";
import { MemoizedAfterInstallPage } from "../../Features/Installer/PhotoCaptureProcess";
import ConnectionTestInterludePage from "../../Features/Installer/ConnectionTestInterludePage";
import ConnectionTestPage from "../../Features/Installer/ConnectionTestPage";
import JobCompletePage from "../../Features/Installer/JobCompletePage";
import { MemoizedWorkAreaBefore } from "../../Features/Installer/WorkAreaBefore";
// import { MemoizedWorkAreaAfter } from "../../Features/Installer/WorkAreaAfter";

import CoordUpdatePage from "../../Features/Installer/CoordUpdatePage.js";
import InstallsPage from "../../Features/Installer/InstallsPage.js";

import { useSelector } from "react-redux";
import { getUserGroups, checkSessionChecked } from "../../Features/Authentication/authSlice";
import { checkIsLoggedIn } from "../../Features/Authentication/authSlice";
import { useIdleClockOut } from "../../Features/Installer/useIdleClockOut";

import QENavbar from "../../Features/QE/Nav/QENavBar";
import QEDashboard from "../../Features/QE/Dashboard";
import PendingInstalls from "../../Features/QE/PendingInstalls";
import History from "../../Features/QE/History";
import InstallDetailsWrapper from "../../Features/QE/InstallDetailWrapper";
import Alerts from "../../Features/Installer/Alerts";
import QRScanUninstall from "../../Features/Installer/Uninstall/QRScanUninstall";
import Uninstall from "../../Features/Installer/Uninstall/Uninstall";
import QRCodeScanReplace from "../../Features/Installer/Replacement/QRCodeScanReplace";
import { DigitalCOCCapture } from "../../Features/QE/DigitalCOCCapture.js";

import FieldAdminLayout, { FieldAdminBackground } from "../../Features/FieldAdmin/Nav/FieldAdminLayout";
import FieldAdminAlerts from "../../Features/FieldAdmin/Alerts";
import FieldAdminSites from "../../Features/FieldAdmin/Sites";
import FieldAdminSiteDetail from "../../Features/FieldAdmin/SiteDetail";
import FieldAdminStock from "../../Features/FieldAdmin/Stock";
import FieldAdminStockCloseOut from "../../Features/FieldAdmin/StockCloseOut";
import FieldAdminStockCollect from "../../Features/FieldAdmin/StockCollect";
import FieldAdminStockIssue from "../../Features/FieldAdmin/StockIssue";
import FieldAdminStockReturn from "../../Features/FieldAdmin/StockReturn";
import FieldAdminHSHub from "../../Features/FieldAdmin/HS/Hub";
import FieldAdminHSVehicle from "../../Features/FieldAdmin/HS/Vehicle";
import FieldAdminHSTools from "../../Features/FieldAdmin/HS/Tools";
import FieldAdminHSAttendance from "../../Features/FieldAdmin/HS/Attendance";
import FieldAdminHSToolbox from "../../Features/FieldAdmin/HS/Toolbox";
import FieldAdminHSDevices from "../../Features/FieldAdmin/HS/Devices";
import FieldAdminHSExport from "../../Features/FieldAdmin/HS/Export";
import FieldAdminHSHistory from "../../Features/FieldAdmin/HS/History";
import FieldAdminQEOversight from "../../Features/FieldAdmin/QEOversight";
import FieldAdminHome from "../../Features/FieldAdmin/Home";
import FieldAdminMore from "../../Features/FieldAdmin/More";
import FieldAdminProfile from "../../Features/FieldAdmin/Profile";
import FieldAdminFleet from "../../Features/FieldAdmin/Fleet";
import FieldAdminTeam from "../../Features/FieldAdmin/Team";
import FieldAdminDevices from "../../Features/FieldAdmin/Devices";


export default function MainRouter() {

  const isLoggedIn = useSelector(checkIsLoggedIn);

  return (
    <>
      <FieldAdminBackground />

      <Routes>
        <Route exact path="/login" element={<LoginPage />}></Route>
        {/* Private Routes */}
        <Route element={<PrivateRoute />}>


          
          <Route element={<AnyUserGroupExists required_user_groups={['global_super_user', 'dsm_installer','neura_ims_admin', 'dsm_qe']} />}>
            <Route exact path="/" element={<><InstallerLandingPage /></>} />
            <Route exact path="/installer/" element={<><InstallerLandingPage /></>} />
            <Route exact path="/installer/uninstall/:install_state/" element={<><QRScanUninstall /></>} />
            <Route exact path="/installer/details/" element={<><ClientDetailsPage /></>} />
            <Route exact path="/installer/alerts/" element={<><Alerts /></>} />
            <Route exact path="/installer/:job_card_reference_id/qrcode/" element={<><QRCodeScanPage /></>} />
            <Route exact path="/installer/:job_card_reference_id/qrcode/replacement/" element={<><QRCodeScanReplace /></>} />
            <Route exact path="/installer/:job_card_reference_id/:serial_number/:imsi_number/work_area_before_install/" element={<><MemoizedWorkAreaBefore /></>} />
            <Route exact path="/installer/:job_card_reference_id/:serial_number/:imsi_number/connection_test_interlude/" element={<><ConnectionTestInterludePage /></>} />
            <Route exact path="/installer/:job_card_reference_id/:serial_number/:imsi_number/:uninstall/" element={<><Uninstall /></>} />
            <Route exact path="/installer/:job_card_reference_id/:serial_number/:imsi_number/details/" element={<><ClientDetailsPage /></>} />
            <Route exact path="/installer/:job_card_reference_id/:serial_number/:imsi_number/connection_test/" element={<><ConnectionTestPage /></>} />
            <Route exact path="/installer/:job_card_reference_id/:serial_number/:imsi_number/after_install/" element={<><MemoizedAfterInstallPage /></>} />
            <Route exact path="/installer/:job_card_reference_id/:serial_number/:imsi_number/job_completed/" element={<><JobCompletePage /></>} />
            <Route exact path="/installer/coords/" element={<><CoordUpdatePage /></>} />
            <Route exact path="/installer/installs/" element={<><InstallsPage /></>} />

          </Route>

          {/* QE Routes inside Private Routes*/}
          <Route element={<AnyUserGroupExists required_user_groups={['global_super_user', 'dsm_qe']} />}>
            <Route exact path="/QE/" element={<><QENavbar/><QEDashboard /></>} />
            <Route exact path="/QE/pending-installs/" element={<><QENavbar/><PendingInstalls /></>} />
            <Route exact path="/QE/history/" element={<><QENavbar/><History /></>} />
            <Route exact path="/QE/:pageName/install/details/:id/" element={<><QENavbar/><InstallDetailsWrapper /></>} />
            <Route exact path="/QE/:pageName/install/details/:id/approve/:job_card_reference_id/:serial_number/:imsi_number/:install_state/" element={<><QENavbar/><DigitalCOCCapture /></>} />
          </Route>

          {/* Route for IMS admin to test device connection*/}
          <Route element={<AnyUserGroupExists required_user_groups={['global_super_user', 'neura_ims_admin']} />}>
          </Route>

          {/* Field Admin Routes inside Private Routes. global_super_user is kept alongside
              dsm_field_admin as a superset so nobody is locked out mid-rollout.
              FieldAdminLayout supplies the chrome and the dark background; the top bar is
              hidden on the 3 Stock forms (which draw their own header via FormPage) and the
              back control on Home (whose design has none — there's nowhere to go back to). */}
          <Route element={<AnyUserGroupExists required_user_groups={['global_super_user', 'dsm_field_admin']} />}>
            <Route exact path="/field-admin/" element={<FieldAdminLayout hideBack><FieldAdminHome /></FieldAdminLayout>} />
            <Route exact path="/field-admin/alerts/" element={<FieldAdminLayout crumb="Alerts"><FieldAdminAlerts /></FieldAdminLayout>} />
            <Route exact path="/field-admin/sites/" element={<FieldAdminLayout crumb="Sites"><FieldAdminSites /></FieldAdminLayout>} />
            <Route exact path="/field-admin/sites/:code/" element={<FieldAdminLayout crumb="Site Detail" backTo="/field-admin/sites/"><FieldAdminSiteDetail /></FieldAdminLayout>} />
            <Route exact path="/field-admin/hs/" element={<FieldAdminLayout crumb="H&S"><FieldAdminHSHub /></FieldAdminLayout>} />
            <Route exact path="/field-admin/hs/vehicle/" element={<FieldAdminLayout crumb="Vehicle Inspection" backTo="/field-admin/hs/"><FieldAdminHSVehicle /></FieldAdminLayout>} />
            <Route exact path="/field-admin/hs/tools/" element={<FieldAdminLayout crumb="Tool Inspection" backTo="/field-admin/hs/"><FieldAdminHSTools /></FieldAdminLayout>} />
            <Route exact path="/field-admin/hs/attendance/" element={<FieldAdminLayout crumb="Attendance" backTo="/field-admin/hs/"><FieldAdminHSAttendance /></FieldAdminLayout>} />
            <Route exact path="/field-admin/hs/toolbox/" element={<FieldAdminLayout crumb="Toolbox Talk" backTo="/field-admin/hs/"><FieldAdminHSToolbox /></FieldAdminLayout>} />
            <Route exact path="/field-admin/hs/devices/" element={<FieldAdminLayout crumb="Device & Data Status" backTo="/field-admin/hs/"><FieldAdminHSDevices /></FieldAdminLayout>} />
            <Route exact path="/field-admin/hs/export/" element={<FieldAdminLayout crumb="Export H&S PDF" backTo="/field-admin/hs/"><FieldAdminHSExport /></FieldAdminLayout>} />
            <Route exact path="/field-admin/hs/history/" element={<FieldAdminLayout crumb="H&S History" backTo="/field-admin/hs/"><FieldAdminHSHistory /></FieldAdminLayout>} />
            <Route exact path="/field-admin/stock/" element={<FieldAdminLayout crumb="Stock"><FieldAdminStock /></FieldAdminLayout>} />
            <Route exact path="/field-admin/stock/balance/" element={<FieldAdminLayout crumb="End-of-Day Balance" backTo="/field-admin/stock/"><FieldAdminStockCloseOut /></FieldAdminLayout>} />
            <Route exact path="/field-admin/stock/collect/" element={<FieldAdminLayout crumb="Scan to Collect" backTo="/field-admin/stock/"><FieldAdminStockCollect /></FieldAdminLayout>} />
            <Route exact path="/field-admin/stock/issue/" element={<FieldAdminLayout crumb="Distribute to Installers" backTo="/field-admin/stock/"><FieldAdminStockIssue /></FieldAdminLayout>} />
            <Route exact path="/field-admin/stock/return/" element={<FieldAdminLayout crumb="Returns &amp; Uninstallable" backTo="/field-admin/stock/"><FieldAdminStockReturn /></FieldAdminLayout>} />
            <Route exact path="/field-admin/more/" element={<FieldAdminLayout crumb="More"><FieldAdminMore /></FieldAdminLayout>} />
            <Route exact path="/field-admin/more/profile/" element={<FieldAdminLayout crumb="Profile" backTo="/field-admin/more/"><FieldAdminProfile /></FieldAdminLayout>} />
            <Route exact path="/field-admin/more/qe-oversight/" element={<FieldAdminLayout crumb="QE Oversight" backTo="/field-admin/more/"><FieldAdminQEOversight /></FieldAdminLayout>} />
            <Route exact path="/field-admin/more/fleet/" element={<FieldAdminLayout crumb="Fleet" backTo="/field-admin/more/"><FieldAdminFleet /></FieldAdminLayout>} />
            <Route exact path="/field-admin/more/team/" element={<FieldAdminLayout crumb="Team" backTo="/field-admin/more/"><FieldAdminTeam /></FieldAdminLayout>} />
            <Route exact path="/field-admin/more/devices/" element={<FieldAdminLayout crumb="Devices" backTo="/field-admin/more/"><FieldAdminDevices /></FieldAdminLayout>} />
          </Route>

     
   
        </Route>

      </Routes>

      <Notifications />
    </>
  );
}

function PrivateRoute() {
  const isLoggedIn = useSelector(checkIsLoggedIn);
  useIdleClockOut();
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
}

function AnyUserGroupExists({ required_user_groups }) {
  const user_groups = useSelector(getUserGroups);
  // Decide on the roles the session refresh returns, not the ones in the cookie at load:
  // a role added since login was refused here before the refresh came back (TF5).
  const sessionChecked = useSelector(checkSessionChecked);
  if (!sessionChecked) return null;
  const permission_check = required_user_groups.some(value => user_groups.includes(value));
  if (permission_check) {
    return <Outlet />
  } else {
    return <Navigate to="/login" />
  }
}

